import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

// Genera/persiste un session id nel localStorage
function getSessionId() {
    let sid = localStorage.getItem("velora_sid");
    if (!sid) {
        sid = "s_" + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
        try { localStorage.setItem("velora_sid", sid); } catch {}
    }
    return sid;
}

function parseUtm(search) {
    const p = new URLSearchParams(search);
    return {
        utm_source: p.get("utm_source") || "",
        utm_medium: p.get("utm_medium") || "",
        utm_campaign: p.get("utm_campaign") || "",
        utm_content: p.get("utm_content") || "",
    };
}

export function PageTracker() {
    const loc = useLocation();
    useEffect(() => {
        // skip admin pages
        if (loc.pathname.startsWith("/admin")) return;
        const payload = {
            path: loc.pathname + (loc.search || ""),
            referrer: document.referrer || "",
            session_id: getSessionId(),
            ...parseUtm(loc.search),
        };
        api.post("/track/pageview", payload).catch(() => {});
    }, [loc.pathname, loc.search]);
    return null;
}
